(ns hai.web-app.feature-flag
  "Provides utilities to use feature-flags.

  Feature flags should not be used as configuration. These are short
  lived code paths which should be treated as technical debt. Aim to
  remove as many feature flags as you think can be removed as quickly
  as they can be removed. We don't want these to balloon up all over
  our codebase and increase the complexity.

  Use wisely, use sparingly."
  (:require
   [hai.web-app.util.rf-storage :as rf-storage]
   [hai.ui.rf-sugar :refer [defevent defevent-fx defsub]]))

;; Beta features — persisted in Datomic on the user entity
(defsub :feature-flag/beta-features?
  [identity :<- :auth/identity]
  (boolean (:user/beta-features? identity)))

(defevent-fx :feature-flag/toggle-beta-features
  [{:keys [db]}]
  (let [new-val (not (get-in db [:auth/identity :user/beta-features?]))]
    {:db (assoc-in db [:auth/identity :user/beta-features?] new-val)
     :resolve {:query `[(~'user/update
                         ~{:user/uuid (-> db :auth/identity :user/uuid)
                           :user/beta-features? new-val})]}}))

;; Developer features — persisted in localStorage
(defsub :feature-flag/developer-features? [db]
  (get-in db [:feature-flag/config :developer-features] false))

(defevent :feature-flag/init <-> [(rf-storage/settings-local)]
  [db]
  (if (contains? (:feature-flag/config db) :developer-features)
    db
    (assoc-in db [:feature-flag/config :developer-features] false)))

(defevent :feature-flag/toggle-developer-features <-> [(rf-storage/settings-local)]
  [db]
  (update-in db [:feature-flag/config :developer-features] not))
